var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hub-editor layout-split" },
    [
      [
        _c("div", { staticClass: "side-panel side-panel-left subnav active" }),
        _vm._v(" "),
        _c("div", { staticClass: "layout-split-right" }, [
          _c(
            "div",
            { staticClass: "audience-main" },
            [
              _c("audience-header", {
                staticClass: "pl-2",
                attrs: {
                  "all-contacts": false,
                  loading: _vm.isLoading || !_vm.segmentLoaded,
                  label: "All Members",
                  "no-audience":
                    !_vm.audiences.length &&
                    !_vm.isLoading &&
                    !_vm.hasFilter &&
                    ((_vm.segment && !_vm.segment.conditionsCount) ||
                      !_vm.segment)
                },
                on: { reset: _vm.reset }
              }),
              _vm._v(" "),
              _vm.hasFilter ||
              (_vm.segment && _vm.segment.conditionsCount) ||
              (_vm.audiences.length && !_vm.isRouteChanged) ||
              _vm.isLoading
                ? _c("audience-table-head", {
                    attrs: {
                      "all-contacts": false,
                      "count-total": _vm.total,
                      "count-selected": _vm.selectedData.length,
                      loading: _vm.isLoading || !_vm.segmentLoaded,
                      empty: !_vm.audiences.length && !_vm.isLoading
                    },
                    on: {
                      "filter-changed": _vm.getAudienceApi,
                      selectAll: function($event) {
                        return _vm.selectAll($event)
                      },
                      sync: function($event) {
                        return _vm.search(true)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              (_vm.audiences.length || _vm.isLoading) && !_vm.isRouteChanged
                ? _c("div", { attrs: { id: "grid-wrapper" } }, [
                    _c(
                      "div",
                      { staticClass: "wrapper-lg px-2" },
                      [
                        _vm.segmentLoaded
                          ? _c("ag-grid-vue", {
                              staticClass:
                                "audience-table ag-table ph-no-capture",
                              class: { disabled: _vm.isLoading },
                              attrs: {
                                gridOptions: _vm.gridOptions,
                                columnDefs: _vm.columnDefs,
                                defaultColDef: _vm.defaultColDef,
                                frameworkComponents: _vm.frameworkComponents,
                                rowData: _vm.audiences
                              },
                              on: {
                                sortChanged: _vm.sortChanged,
                                "row-clicked": function($event) {
                                  return _vm.selectRow($event, "Show")
                                },
                                "grid-ready": _vm.onGridReady,
                                "grid-size-changed": _vm.onGridSizeChanged,
                                "selection-changed": _vm.onSelectionChanged
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", appear: "" } }, [
                _vm.isLoading || _vm.isRouteChanged
                  ? _c("div", { key: "loading" }, [
                      _c(
                        "div",
                        { staticClass: "wrapper-lg px-2" },
                        _vm._l(20, function(elem) {
                          return _c(
                            "div",
                            { staticClass: "audience-skeleton" },
                            [
                              _c("span", { staticClass: "skeleton-avatar" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "skeleton-lines" }, [
                                _c("i", { staticClass: "skeleton-title" }),
                                _vm._v(" "),
                                _c("i", { staticClass: "skeleton-subtitle" })
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : !_vm.isLoading &&
                    !_vm.isRouteChanged &&
                    !_vm.audiences.length
                  ? _c(
                      "div",
                      {
                        key: "empty",
                        staticClass: "side-panel-group-empty txt-center"
                      },
                      [
                        _vm.hasFilter ||
                        (_vm.segment && _vm.segment.conditionsCount)
                          ? [
                              _c("illustration-dog-digging"),
                              _vm._v(" "),
                              _c(
                                "h4",
                                { staticClass: "txt-heading txt-bold mt-4" },
                                [_vm._v("No Members Found")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "txt-body txt-muted" }, [
                                _vm._v(
                                  "We couldn’t find anyone matching your search. "
                                ),
                                _c("br"),
                                _vm._v(
                                  "Try adjusting your filters or search terms."
                                )
                              ])
                            ]
                          : !_vm.hasFilter && !_vm.segment
                          ? [
                              _c("illustration-dog-bowl"),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass: "txt-heading txt-bold mt-4 mb-2"
                                },
                                [_vm._v("No Members Yet")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "txt-body txt-muted" },
                                [
                                  _vm._v(
                                    "Once people join your Hub, they’ll appear here."
                                  ),
                                  _c("br"),
                                  _vm._v("Add members to get started!")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  attrs: { variant: "primary mt-4" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.openMemberDialog($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "btn-left",
                                      attrs: { viewBox: "0 0 24 24" }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#icon-user-add"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b", [_vm._v("Add Member")])
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wrapper-lg" }, [
                _vm.nextCursor !== undefined || _vm.prevCursor !== undefined
                  ? _c("div", { staticClass: "pagination" }, [
                      _c(
                        "div",
                        { staticClass: "pagination-inner w-100" },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "mx-0 mr-auto",
                              attrs: {
                                variant: "icon primary",
                                disabled: _vm.prevCursor === undefined
                              },
                              on: {
                                click: function($event) {
                                  return _vm.goToCursor(_vm.prevCursor)
                                }
                              }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "btn-left",
                                  attrs: { viewBox: "0 0 24 24" }
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#icon-arrow-left" }
                                  })
                                ]
                              ),
                              _vm._v(
                                "\n                Previous Page\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "mx-0 ml-auto",
                              attrs: {
                                variant: "icon primary",
                                disabled: _vm.nextCursor === undefined
                              },
                              on: {
                                click: function($event) {
                                  return _vm.goToCursor(_vm.nextCursor)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Next Page\n                "
                              ),
                              _c(
                                "svg",
                                {
                                  staticClass: "btn-right",
                                  attrs: { viewBox: "0 0 24 24" }
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#icon-arrow-right" }
                                  })
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("export-dialog"),
              _vm._v(" "),
              _c("segment-dialog"),
              _vm._v(" "),
              _vm.audience
                ? _c(
                    "delete-dialog",
                    {
                      attrs: {
                        id: "audience-delete-dialog",
                        title: "Delete Member",
                        processing: _vm.isDeleting
                      },
                      on: { accept: _vm.deleteAudience }
                    },
                    [
                      _c("div", { staticClass: "txt-heading-small" }, [
                        _vm._v(
                          "\n            Are you sure you want to delete "
                        ),
                        _c("br"),
                        _c("b", [_vm._v(_vm._s(_vm.audience.name))]),
                        _vm._v("?\n          ")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("audience-segment-dialogs"),
              _vm._v(" "),
              _c("bulk-dialog"),
              _vm._v(" "),
              _c("exit-dialog", {
                attrs: {
                  id: "exit-person-dialog",
                  static: false,
                  subtitle: _vm.exitDialogSubtitle,
                  title: "Save changes before exit?",
                  description: "Unsaved data will be lost.",
                  "accept-label": "Save & Exit",
                  "reject-label": "Exit"
                },
                on: {
                  reject: _vm.rejectPersonSettingsExit,
                  accept: _vm.acceptPersonSettingsExit
                }
              }),
              _vm._v(" "),
              _c("exit-dialog", {
                attrs: {
                  id: "audience-bulk-dialog",
                  static: false,
                  title: "Would you like to apply changes before leaving?",
                  subtitle: "",
                  description: "Unapplied changes will be lost.",
                  "accept-label": "Apply & Close",
                  "reject-label": "Close"
                },
                on: {
                  reject: _vm.rejectAudienceBulk,
                  accept: _vm.acceptAudienceBulk
                },
                scopedSlots: _vm._u([
                  {
                    key: "subtitle",
                    fn: function() {
                      return [
                        _c("b", { staticClass: "txt-primary" }, [
                          _vm._v("Apply Edits?")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _vm._v(" "),
              _vm.exportItem
                ? _c("delete-dialog", {
                    attrs: {
                      id: "export-delete-dialog",
                      title: "Delete Export",
                      "resource-name": _vm.exportItem.title,
                      processing: _vm.isDeleting
                    },
                    on: { accept: _vm.deleteExport }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedAudience
                ? _c(
                    "delete-dialog",
                    {
                      attrs: {
                        id: "bulk-delete-dialog",
                        title: "Remove Members",
                        processing: _vm.isDeleting
                      },
                      on: { accept: _vm.deleteBulkAudience }
                    },
                    [
                      _c("div", { staticClass: "txt-heading-small" }, [
                        _vm._v(
                          "\n            Are you sure you want to remove "
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.selectedAudience.length) +
                              " " +
                              _vm._s(
                                _vm.selectedAudience.length > 1
                                  ? "members"
                                  : "member"
                              )
                          )
                        ]),
                        _vm._v(" from your Hub?\n          ")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedAudience
                ? _c(
                    "delete-dialog",
                    {
                      attrs: {
                        id: "bulk-remove-dialog",
                        title: "Remove Members",
                        processing: _vm.isRemoving,
                        deleteButtonLabel: "Remove"
                      },
                      on: { accept: _vm.removeBulkAudience }
                    },
                    [
                      _c("div", { staticClass: "txt-heading-small" }, [
                        _vm._v(
                          "\n            Are you sure you want to remove "
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.selectedAudience.length) +
                              " " +
                              _vm._s(
                                _vm.selectedAudience.length > 1
                                  ? "members"
                                  : "member"
                              )
                          )
                        ]),
                        _vm._v(" from your Hub?\n          ")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.exportItem
                ? _c("rename-dialog", {
                    attrs: {
                      id: "export-rename-dialog",
                      title: "Rename",
                      processing: _vm.renameProcessing,
                      placeholder: "Enter new title here"
                    },
                    on: { accept: _vm.renameExport },
                    model: {
                      value: _vm.exportItem.title,
                      callback: function($$v) {
                        _vm.$set(_vm.exportItem, "title", $$v)
                      },
                      expression: "exportItem.title"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        !_vm.segmentLoaded
          ? _c("div", { key: "loading" }, [
              _c(
                "div",
                {
                  staticClass:
                    "wrapper-lg px-2 hub-editor-preview-loading w-100 mt-3 no-bg",
                  staticStyle: {
                    "margin-left": "320px",
                    "justify-content": "flex-start"
                  }
                },
                _vm._l(20, function(elem) {
                  return _c("div", { staticClass: "audience-skeleton w-100" }, [
                    _c("span", { staticClass: "skeleton-avatar" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "skeleton-lines" }, [
                      _c("i", { staticClass: "skeleton-title" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "skeleton-subtitle" })
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }